import { getElementsById } from "core-integration/src/store/elements/reducers";
import { getRules } from "core-integration/src/store/game/reducers";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import { useSelector } from "react-redux";
import Shirt from "../Shirt";
import { ElementShirtProps } from "./types";

const getElementShirtPath = (
  elementType: number,
  teamCode: number,
  shirtMode: string,
) => {
  const suffix = elementType === 1 ? `_${elementType}` : "";
  return `/dist/img/shirts/${shirtMode}/shirt_${teamCode}${suffix}`;
};

const ElementShirt = ({ elementId, teamId, alt, sizes }: ElementShirtProps) => {
  const element = useSelector(getElementsById)[elementId];
  const rules = useSelector(getRules);
  const team = useSelector(getTeamsById)[teamId ?? element.team];

  let shirtMode = "standard";
  if (rules && rules.ui_use_special_shirts) {
    if (rules.ui_special_shirt_exclusions.indexOf(element.code) === -1) {
      shirtMode = "special";
    }
  }

  return (
    <Shirt
      alt={alt}
      path={getElementShirtPath(
        element.element_type,
        element.has_temporary_code ? 0 : team.code,
        shirtMode,
      )}
      sizes={sizes}
    />
  );
};

export default ElementShirt;
